import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';

export const SUB_AREA_ACTION_TYPES = {
	GET__SUB_AREAS_SUCCESS: 'GET__SUB_AREAS_SUCCESS',
    POST_SUB_AREA_SUCCESS: 'POST_SUB_AREA_SUCCESS',
    PUT_SUB_AREA_SUCCESS: 'PUT_SUB_AREA_SUCCESS',
    DELETE_SUB_AREA_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_SUB_AREAS_PAGINATION: 'UPDATE_SUB_AREAS_PAGINATION'
};

const SUB_AREAS_URL = `${ENTRYPOINT}${API_ROUTES.SUB_AREAS}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

const formatData = (data) => {
    if (data.area) {
        data.area = `/api/areas/${data.area.uuid}`;
    }
    return data;
}

export const getSubAreas = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(formatData(data));
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_AREAS_URL = `${SUB_AREAS_URL}${params}`;
        const response = await getData(GET_AREAS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: SUB_AREA_ACTION_TYPES.GET__SUB_AREAS_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: SUB_AREA_ACTION_TYPES.UPDATE_SUB_AREAS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getSubArea = async (uuid) => {
    const GET_SUB_AREA_URL = `${SUB_AREAS_URL}/${uuid}`;
    return await getData(GET_SUB_AREA_URL, getHeaders());
}

export const postSubArea = (data) => {
    return async (dispatch) => {
        const response = await postData(SUB_AREAS_URL,formatData(data));
        dispatch({ type: SUB_AREA_ACTION_TYPES.POST_SUB_AREA_SUCCESS, payload: response });
        return response;
    }
}

export const putSubArea = (uuid, data) => {
    return async (dispatch) => {
        const PUT_AREA_URL = `${SUB_AREAS_URL}/${uuid}`;
        const response = await putData(PUT_AREA_URL, formatData(data));
        dispatch({ type: SUB_AREA_ACTION_TYPES.PUT_SUB_AREA_SUCCESS, payload: response });
        return response;
    }
}

export const deleteSubArea = (uuid) => (
    async () => {
        const DELETE_SUB_AREA_URL = `${SUB_AREAS_URL}/${uuid}`;
        await deleteData(DELETE_SUB_AREA_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateSubAreasPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: SUB_AREA_ACTION_TYPES.UPDATE_SUB_AREAS_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getSubAreas({ page, rowsPerPage, filters }));
    }
}

